import { jsxs as N, jsx as g } from "react/jsx-runtime";
import { useState as $, useRef as V, useEffect as A } from "react";
import { p as B } from "./purify.es-C_c8wluz.mjs";
import { h as E, A as z, a as T } from "./common-utils-Bb7wjgT2.mjs";
const O = (o) => {
  var S, F, b, v;
  const {
    item: e,
    depthLevel: s,
    index: a,
    currentFocusMenu: n,
    totalSubmenus: p,
    dropdownIndex: l,
    styles: u,
    updateCurrFocusedIndex: c,
    textSizeClass: f,
    itemCountDown: C,
    parentDropdownLength: I,
    parentName: M,
    enableAnalytics: m
  } = o, [d, r] = $(!1), [t, w] = $(!1), i = V(null);
  A(() => {
    (l ?? 0) + a === n && (i != null && i.current) && i.current.focus();
  }, [n, i.current]), A(() => {
    if (n === null) {
      d && r(!1);
      return;
    }
    n >= (l ?? 0) + a && n <= (l ?? 0) + a + (p || 0) ? r(D && k) : r(!1);
  }, [n]);
  const D = ((F = (S = e == null ? void 0 : e.HstMenuItemRepresentation) == null ? void 0 : S.parameters) == null ? void 0 : F.showDropdown) === "true", k = !!((v = (b = e == null ? void 0 : e.HstMenuItemRepresentation) == null ? void 0 : b.menuItems) != null && v.length), H = {
    color: t ? u.linkTextColorHover : u.linkTextColor,
    backgroundColor: "#FFFFFF"
  };
  t && (H.backgroundColor = u.navTabHoverBackgroundColor);
  const R = () => {
    r(D && k), w(!0);
  }, y = () => {
    r(!1), w(!1);
  }, L = () => {
    const h = (l ?? 0) + a;
    n !== h && c(h), R();
  }, x = `${M} | ${e.HstMenuItemRepresentation.name}`;
  return /* @__PURE__ */ N(
    "li",
    {
      onMouseEnter: R,
      onMouseLeave: y,
      className: `menu-items menu-items-${s} ${f}`,
      children: [
        /* @__PURE__ */ N(
          "a",
          {
            onFocus: L,
            onBlur: y,
            onClick: m ? (h) => E(
              h,
              z.NAV_TRAY,
              x,
              e.HstMenuItemRepresentation.parameters.analyticsSatellite
            ) : void 0,
            ref: i,
            className: `${t ? "" : "u-linkClean"} u-flex u-flexAlignItemsCenter u-flexJustifyBetween u-paddingHoriz3gu u-paddingVert2gu u-posRelative`,
            style: H,
            "data-analytics": x,
            href: B.sanitize(e.HstMenuItemRepresentation.url),
            children: [
              e.HstMenuItemRepresentation.name,
              " ",
              D && k && /* @__PURE__ */ g(
                "span",
                {
                  className: "adel-material-symbols-18 arrow-right",
                  role: "img",
                  "aria-label": "Chevron Right",
                  children: "chevron_right"
                }
              )
            ]
          }
        ),
        d && /* @__PURE__ */ g(
          Y,
          {
            depthLevel: s,
            submenus: e.HstMenuItemRepresentation.menuItems || [],
            dropdown: d,
            dropdownIndex: a + (l ?? 0) + 1,
            styles: u,
            currentFocusMenu: n,
            totalSubmenus: p,
            updateCurrFocusedIndex: c,
            textSizeClass: f,
            countDownOffset: C,
            parentDropdownLength: I,
            parentName: x,
            enableAnalytics: m
          }
        )
      ]
    }
  );
}, Y = ({
  submenus: o,
  dropdown: e,
  depthLevel: s,
  dropdownIndex: a,
  currentFocusMenu: n,
  styles: p,
  updateCurrFocusedIndex: l,
  textSizeClass: u,
  countDownOffset: c,
  parentDropdownLength: f,
  parentName: C,
  enableAnalytics: I
}) => {
  s = s + 1;
  const M = +s > 1 ? "dropdown-submenu" : "";
  let m = 0;
  const d = c + o.length - 1 < f && +s > 1 ? "dropdown--square" : "";
  return o.length > 0 && /* @__PURE__ */ g(
    "ul",
    {
      className: `dropdown ${M} ${e ? "show" : "u-hidden"} ${d}`,
      children: o.map((r, t) => {
        const w = T(o[t]);
        return m += t === 0 ? 0 : T(o[t - 1]), /* @__PURE__ */ g(
          O,
          {
            item: r,
            dropdownIndex: a,
            depthLevel: s,
            index: t + m,
            totalSubmenus: w,
            styles: p,
            currentFocusMenu: n,
            itemCountDown: t + c,
            parentDropdownLength: o.length - 1,
            updateCurrFocusedIndex: l,
            textSizeClass: u,
            parentName: C,
            enableAnalytics: I
          },
          r.HstMenuItemRepresentation.name
        );
      })
    }
  );
};
export {
  Y as D,
  O as a
};
//# sourceMappingURL=Dropdown-CQArAytM.mjs.map
